/* QUICKVIEW — genau EINE Modal-Instanz (Singleton). Trello Jef4BCDO.
   Frueher wurde pro Produktkachel ein eigenes <custom-quickview> erzeugt
   (z. B. 57x auf der Startseite). Hier wird stattdessen genau eine Instanz
   wiederverwendet: beim Oeffnen wird sie in die geklickte Karte eingehaengt,
   damit Positionierung und CSS (.product-card-wrapper .quick-add-popup)
   exakt identisch bleiben; geschlossen wird sie in einen versteckten Halter
   ausserhalb der Grids geparkt, damit Globo-/AJAX-Re-Renders sie nicht
   zerstoeren. Der globale Name onClickQuickView bleibt erhalten, damit auch
   das (nicht editierbare) globo.filter.product.liquid weiter funktioniert. */
var QV_modal = null;        // das eine Singleton-Modal
var QV_holder = null;       // versteckter Park-Container ausserhalb der Produkt-Grids
var QV_lastTrigger = null;  // ausloesender Button — fuer die Fokusrueckgabe (a11y)
var QV_i18n = {};           // Texte aus den Theme-Locales (Trello ghCjefQj)
var QV_inerted = [];        // Hintergrund-Elemente, die bei offenem Dialog inert gesetzt wurden (Trello STSG6KAW)

// Locale-Strings vom Trigger einlesen (per data-Attribute aus card-product.liquid;
// dort via {{ '...' | t }} lokalisiert). Wird gecacht, damit auch von Globo
// gerenderte Trigger ohne eigene Attribute die Texte nutzen koennen.
function QV_readI18n(el) {
  if (!el || !el.dataset) return;
  var d = el.dataset;
  if (d.qvLoading != null) QV_i18n.loading = d.qvLoading;
  if (d.qvNotFound != null) QV_i18n.notFound = d.qvNotFound;
  if (d.qvError != null) QV_i18n.error = d.qvError;
  if (d.qvLabel != null) QV_i18n.label = d.qvLabel;
  if (d.qvClose != null) QV_i18n.close = d.qvClose;
}

// Statusmeldung als Absatz; nur lokalisierte Texte, keine hartkodierten Strings.
function QV_msg(text) {
  var p = document.createElement('p');
  p.textContent = text || '';
  return p.outerHTML;
}

function QV_getHolder() {
  if (QV_holder && document.contains(QV_holder)) return QV_holder;
  QV_holder = document.createElement('div');
  // product-card-wrapper zusaetzlich, damit die Quickview-Styles aus
  // card-product.css auch greifen, wenn das Modal im Holder angezeigt wird (mobil).
  QV_holder.className = 'quickview-holder product-card-wrapper';
  QV_holder.style.display = 'none';
  document.body.appendChild(QV_holder);
  return QV_holder;
}

// Liefert das Singleton-Modal: erste vorhandene Instanz uebernehmen, alle
// weiteren entfernen. Funktioniert unabhaengig davon, welches Snippet die
// Instanz gerendert hat (card-product.liquid oder globo.filter.product.liquid).
function QV_getModal() {
  if (QV_modal && document.contains(QV_modal)) return QV_modal;

  var all = document.querySelectorAll('custom-quickview');
  if (!all.length) return null;

  QV_modal = all[0];
  for (var i = 1; i < all.length; i++) all[i].remove();
  QV_modal.removeAttribute('id'); // doppelte id "quickview-modal" vermeiden
  QV_prepare(QV_modal);
  QV_getHolder().appendChild(QV_modal); // parken
  return QV_modal;
}

// Barrierefreiheit (Trello Nz11ZB1V): Dialog-Semantik + Fokusfalle/ESC einmalig
// am Singleton einrichten.
function QV_prepare(modal) {
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex', '-1');
  modal.style.outline = 'none'; // Container ist kein Bedienelement -> kein sichtbarer Fokusring
  modal.addEventListener('keydown', QV_onKeydown);
}

// Hintergrund inert setzen (Trello STSG6KAW): aria-modal allein wird nicht von
// allen Screenreadern beachtet — der Lesemodus (virtueller Cursor) kann sonst
// hinter dem offenen Dialog weiterwandern. Da das Modal INNERHALB der Produkt-
// karte (also innerhalb von <main>) haengt, darf nicht einfach <main> inert
// werden — das wuerde den Dialog selbst deaktivieren. Stattdessen werden alle
// Geschwister der Vorfahren-Kette des Modals bis <body> inert gesetzt.
// Ausgenommen: cart-drawer/cart-notification (oeffnet sich nach In-den-Warenkorb
// aus dem Quickview und muss bedienbar bleiben) sowie script/style/link.
function QV_setBackgroundInert() {
  QV_releaseBackgroundInert(); // nie stapeln (z. B. Oeffnen auf anderer Karte)
  if (!QV_modal) return;
  var node = QV_modal;
  while (node && node.parentElement && node !== document.body) {
    var siblings = node.parentElement.children;
    for (var i = 0; i < siblings.length; i++) {
      var el = siblings[i];
      if (el === node) continue;
      var tag = el.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'TEMPLATE') continue;
      if (tag === 'CART-DRAWER' || tag === 'CART-NOTIFICATION') continue;
      if ('inert' in el) {
        if (el.inert) continue; // fremden Zustand nicht anfassen (und nicht zuruecksetzen)
        el.inert = true;
        QV_inerted.push({ el: el, attr: false });
      } else if (!el.hasAttribute('aria-hidden')) { // Fallback fuer sehr alte Browser
        el.setAttribute('aria-hidden', 'true');
        QV_inerted.push({ el: el, attr: true });
      }
    }
    node = node.parentElement;
  }
}

// Beim Schliessen exakt zuruecksetzen — nur, was wir selbst gesetzt haben.
function QV_releaseBackgroundInert() {
  for (var i = 0; i < QV_inerted.length; i++) {
    var it = QV_inerted[i];
    if (it.attr) it.el.removeAttribute('aria-hidden');
    else it.el.inert = false;
  }
  QV_inerted = [];
}

// Sichtbare, fokussierbare Elemente innerhalb des Modals.
function QV_focusables(container) {
  var sel = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  return Array.prototype.filter.call(container.querySelectorAll(sel), function (el) {
    return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
  });
}

// ESC schliesst, Tab/Shift+Tab bleibt im Modal gefangen (Fokusfalle).
function QV_onKeydown(e) {
  if (e.key === 'Escape' || e.keyCode === 27) {
    e.preventDefault();
    QV_close();
    return;
  }
  if (e.key === 'Tab' || e.keyCode === 9) {
    var f = QV_focusables(QV_modal);
    if (!f.length) { e.preventDefault(); QV_modal.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }
}

function onClickQuickView(button) {
  var productUrl = button.getAttribute('data-url');
  if (!productUrl) return;

  QV_readI18n(button);

  var modal = QV_getModal();
  if (!modal) return;

  var card = button.closest('[card-wrapper]');
  // Mobil: im body-Holder anzeigen (viewport-zentriert per CSS) — in der Karte
  // wuerde das Popup seitlich abgeschnitten und position:fixed braeche in
  // Slidern an transform-Vorfahren. Desktop: wie bisher in die Karte.
  if (window.matchMedia('(max-width: 749px)').matches) {
    var mobileHolder = QV_getHolder();
    mobileHolder.appendChild(modal);
    mobileHolder.style.display = 'block';
  } else if (card) {
    card.appendChild(modal); // in die geklickte Karte einhaengen
  }

  QV_lastTrigger = button; // fuer Fokusrueckgabe beim Schliessen

  var modalContent = modal.querySelector('[quickview-content]');
  var closeBtn = modal.querySelector('[close-quickview]');
  if (closeBtn && QV_i18n.close) closeBtn.setAttribute('aria-label', QV_i18n.close);
  if (QV_i18n.label) modal.setAttribute('aria-label', QV_i18n.label);

  document.body.classList.add('modal-open');
  modal.classList.add('active');
  QV_setBackgroundInert(); // Hintergrund fuer Screenreader/Interaktion sperren (Trello STSG6KAW)
  modalContent.innerHTML = QV_msg(QV_i18n.loading);

  modal.focus({ preventScroll: true }); // Fokus in den Dialog (Screenreader betritt das Modal)

  fetch(productUrl)
    .then(function (response) { return response.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var productInfo = doc.querySelector('quickview-product-info');
      if (productInfo) {
        // Locale-Texte robust aus dem (in-scope) Quickview-Inhalt nachladen —
        // unabhaengig davon, ob der ausloesende Trigger data-qv-* trug (z. B.
        // Globo-Trigger auf Collection-Seiten). Vor preventDuplicatedIDs lesen.
        QV_readI18n(productInfo);
        if (closeBtn && QV_i18n.close) closeBtn.setAttribute('aria-label', QV_i18n.close);
        preventDuplicatedIDs(productInfo);
        preventVariantURLSwitching(productInfo);
        removeDOMElements(productInfo);
        HTMLUpdateUtility.setInnerHTML(modalContent, productInfo.outerHTML);
        QV_labelByTitle(modal, modalContent); // Dialog mit Produkttitel benennen
        QV_focusInto(modal);                  // Fokus auf den Dialog-Container (kein sichtbarer Ring)
      } else {
        modalContent.innerHTML = QV_msg(QV_i18n.notFound);
      }
    })
    .catch(function (error) {
      console.error('Error:', error);
      modalContent.innerHTML = QV_msg(QV_i18n.error);
    });
}

// aria-label des Dialogs aus dem geladenen Produkttitel (sprachneutral korrekt).
function QV_labelByTitle(modal, content) {
  var title = content.querySelector('.product__title .h2, .product__title h1, .product__title h2, h1, h2');
  if (title) {
    var text = title.textContent.replace(/\s+/g, ' ').trim();
    if (text) modal.setAttribute('aria-label', text);
  }
}

// Fokus auf den Dialog-Container (nicht auf ein Bedienelement) — der Dialog wird
// per role/aria-label angekuendigt, Maus-Nutzer sehen keinen Fokusring auf dem X.
function QV_focusInto(modal) {
  modal.focus({ preventScroll: true });
}

function QV_close() {
  if (!QV_modal) return;
  QV_modal.classList.remove('active');
  var modalContent = QV_modal.querySelector('[quickview-content]');
  if (modalContent) modalContent.innerHTML = '';
  document.body.classList.remove('modal-open');
  QV_releaseBackgroundInert(); // VOR der Fokusrueckgabe — inerte Elemente sind nicht fokussierbar
  var holder = QV_getHolder();
  holder.appendChild(QV_modal); // zurueck in den versteckten Halter
  holder.style.display = 'none';
  if (QV_lastTrigger && document.contains(QV_lastTrigger)) {
    QV_lastTrigger.focus(); // Fokus zurueck auf den ausloesenden Button
  }
  QV_lastTrigger = null;
}

// Schliessen per Klick auf das X (delegiert) ODER ausserhalb des Fensters
// (Betreiber-Wunsch 06.07.: sonst wirkt die Seite „tot“, wenn man das offene
// Fenster vergisst — der erste Klick daneben schliesst es jetzt einfach).
// Ausgenommen: der ausloesende Trigger (sonst wuerde der Oeffnen-Klick sofort
// wieder schliessen) und der Cart-Drawer (oeffnet sich nach In-den-Warenkorb
// ueber dem Fenster und muss bedienbar bleiben, s. QV_setBackgroundInert).
document.addEventListener('click', function (e) {
  if (!(e.target instanceof Element)) return;
  if (e.target.closest('[close-quickview]')) { QV_close(); return; }
  if (!QV_modal || !QV_modal.classList.contains('active')) return;
  if (QV_modal.contains(e.target)) return;
  if (QV_lastTrigger && QV_lastTrigger.contains(e.target)) return;
  if (e.target.closest('cart-drawer, cart-notification')) return;
  QV_close();
});

// Singleton sicherstellen, sobald das DOM bereit ist, und Globo-/AJAX-
// Re-Renders abfangen: neu eingefuegte Per-Kachel-Modals entfernen, das
// geparkte Singleton bleibt erhalten.
var QV_cleanupScheduled = false;

// Entfernt von Globo/AJAX nachgerenderte Per-Kachel-Modals — gebuendelt EINMAL
// pro Frame, damit haeufige DOM-Updates (Mengen-Stepper, Cart-Drawer) nicht
// ruckeln. Der Observer-Callback selbst ist O(1) und setzt nur ein Flag.
function QV_scheduleCleanup() {
  if (QV_cleanupScheduled) return;
  QV_cleanupScheduled = true;
  var run = function () {
    QV_cleanupScheduled = false;
    if (!QV_modal) return;
    var all = document.querySelectorAll('custom-quickview');
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== QV_modal) all[i].remove();
    }
  };
  if (window.requestAnimationFrame) window.requestAnimationFrame(run);
  else window.setTimeout(run, 50);
}

function QV_init() {
  if (window.__quickviewInit) return; // Doppel-Init vermeiden (z. B. Hot-Reload)
  window.__quickviewInit = true;

  var t = document.querySelector('[custom-quickview][data-qv-loading]');
  if (t) QV_readI18n(t); // Locale-Texte fruehzeitig cachen (falls Trigger vorhanden)
  QV_getModal();

  // Globo-/AJAX-Re-Renders abfangen (debounced, siehe QV_scheduleCleanup).
  new MutationObserver(QV_scheduleCleanup).observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', QV_init);
} else {
  QV_init();
}



// articl page quick
const quickButtonsBlog = document.querySelectorAll('[custom-quickview-blog]');

quickButtonsBlog.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();

    const productUrl = this.getAttribute('data-url');
    if (!productUrl) return;

    const originalParent = this.parentNode;

    // Check if already wrapped, if not create wrapper
    let wrapper = this.closest('.quick-wrap');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'quick-wrap';

      // Insert wrapper in original position and move button inside
      originalParent.insertBefore(wrapper, this);
      wrapper.appendChild(this);
    } else {
      // Remove old modal if exists
      const existingModal = wrapper.querySelector('.quick-add-popup');
      if (existingModal) existingModal.remove();
    }

    // Create modal inside wrapper
    const modal = document.createElement('custom-quickview-blog');
    modal.className = 'quickview-modal quick-add-popup';
    modal.innerHTML = `
      <button class="close-quickview" close-quickview-blog aria-label="${QV_i18n.close || ''}">×</button>
      <div class="quickview-content" quickview-content>${QV_msg(QV_i18n.loading)}</div>
    `;
    wrapper.appendChild(modal);

    // Fetch product info
    fetch(productUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const productInfo = doc.querySelector('quickview-product-info'); // Adjust selector
        preventDuplicatedIDs(productInfo);
        removeDOMElements(productInfo);
        preventVariantURLSwitching(productInfo)
        const modalContent = modal.querySelector('[quickview-content]');
        modalContent.innerHTML = productInfo ? productInfo.innerHTML : QV_msg(QV_i18n.notFound);
      })
      .catch(error => {
        console.error('Error:', error);
        modal.querySelector('[quickview-content]').innerHTML = QV_msg(QV_i18n.error);
      });

    // Close button functionality
    modal.querySelector('[close-quickview-blog]').addEventListener('click', function () {
      // Move button back to original parent
      originalParent.insertBefore(button, wrapper);
      // Remove wrapper
      wrapper.remove();
    });
  });
});


 function preventVariantURLSwitching(productElement) {
    productElement.setAttribute('data-update-url', 'false');
  }

// The quickview injects a second copy of the product section into a page that
// may already contain it (e.g. product recommendations on a PDP). Element IDs
// embed the section id, so every occurrence of it is rewritten to
// "quickadd-<sectionId>" to keep IDs unique and stop scripts/labels from
// targeting the page's original elements. Plain string replace over innerHTML:
// it also hits non-ID text containing the section id, which is acceptable
// because section ids are long numeric/template strings. dataset.originalSection
// keeps the real id for section-rendering requests.
function preventDuplicatedIDs(productElement) {
    const sectionId = productElement.dataset.section;
    const oldId = sectionId;
    const newId = `quickadd-${sectionId}`;
    productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
    Array.from(productElement.attributes).forEach((attribute) => {
      if (attribute.value.includes(oldId)) {
        productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
      }
    });

    productElement.dataset.originalSection = sectionId;
  }

function removeDOMElements(productElement) {
  // console.log(":productElement",productElement);

  const pickupAvailability = productElement.querySelector('pickup-availability');
  if (pickupAvailability) pickupAvailability.remove();

  const personalData = productElement.querySelector('.person-info-container');
  if (personalData) personalData.remove();

  const media_gallery = productElement.querySelector('.product__media-wrapper');
  if (media_gallery) media_gallery.remove();

  const product_features = productElement.querySelector('.product_features');
  if (product_features) product_features.remove();

  const productModal = productElement.querySelector('product-modal');
  if (productModal) productModal.remove();

  const modalDialog = productElement.querySelectorAll('modal-dialog');
  if (modalDialog) modalDialog.forEach((modal) => modal.remove());
}


const accordionItems = document.querySelectorAll('[accordion]');

accordionItems.forEach((item, index) => {
  const title = item.querySelector('[accordion__title]');
  const content = item.querySelector('[faq_accordion__content]');

  // A11y (BFSG/WCAG 2.1.1 + 4.1.2): div-Trigger tastaturbedienbar machen + fuer Screenreader auszeichnen
  if (title) {
    if (content && !content.id) content.id = 'faq-content-' + index;
    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');
    if (content) title.setAttribute('aria-controls', content.id);
  }

  if (index === 0) {
    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  } else {
    content.style.maxHeight = null;
  }
  if (title) title.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');

  const toggle = function () {
    const isActive = item.classList.contains('active');

    accordionItems.forEach((otherItem) => {
      otherItem.classList.remove('active');
      otherItem.querySelector('[faq_accordion__content]').style.maxHeight = null;
      const otherTitle = otherItem.querySelector('[accordion__title]');
      if (otherTitle) otherTitle.setAttribute('aria-expanded', 'false');
    });

    if (!isActive) {
      item.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
      if (title) title.setAttribute('aria-expanded', 'true');
    }
  };

  if (title) {
    title.addEventListener('click', toggle);
    title.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggle();
      }
    });
  }
});




/*const tabNavItems = document.querySelectorAll(".tab-nav-title");
const tabContents = document.querySelectorAll(".tabs-content-wrapper");

if (tabNavItems.length && tabContents.length) {
  tabNavItems.forEach((tab, index) => {
    const link = tab.querySelector("a");
    if (index === 0) {
      tab.classList.add("active");
      if (link) {
        link.classList.remove("button--secondary");
        link.classList.add("button--primary");
      }
      tabContents[index].style.display = "block";
    } else {
      if (link) {
        link.classList.remove("button--primary");
        link.classList.add("button--secondary");
      }
      tabContents[index].style.display = "none";
    }
  });

  tabNavItems.forEach((tab, index) => {
    const link = tab.querySelector("a");
    if (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        tabNavItems.forEach((t, i) => {
          const tLink = t.querySelector("a");
          t.classList.remove("active");
          if (tLink) {
            tLink.classList.remove("button--primary");
            tLink.classList.add("button--secondary");
          }
          tabContents[i].style.display = "none";
        });

        tab.classList.add("active");
        link.classList.remove("button--secondary");
        link.classList.add("button--primary");
        tabContents[index].style.display = "block";
      });
    }
  });
} */

  document.querySelectorAll(".tabs-main-wrapper").forEach((tabsWrapper) => {
  const tabNavItems = tabsWrapper.querySelectorAll(".tab-nav-title");
  const tabContents = tabsWrapper.querySelectorAll(".tabs-content-wrapper");

  if (!tabNavItems.length || !tabContents.length) return;

  tabNavItems.forEach((tab, index) => {
    const link = tab.querySelector("a");

    if (index === 0) {
      tab.classList.add("active");
      if (link) {
        link.classList.remove("button--secondary");
        link.classList.add("button--primary");
      }
      if (tabContents[index]) {
        tabContents[index].style.display = "block";
      }
    } else {
      if (link) {
        link.classList.remove("button--primary");
        link.classList.add("button--secondary");
      }
      if (tabContents[index]) {
        tabContents[index].style.display = "none";
      }
    }
  });

  tabNavItems.forEach((tab, index) => {
    const link = tab.querySelector("a");

    if (!link) return;

    link.addEventListener("click", function (e) {
      e.preventDefault();

      tabNavItems.forEach((t, i) => {
        const tLink = t.querySelector("a");
        t.classList.remove("active");

        if (tLink) {
          tLink.classList.remove("button--primary");
          tLink.classList.add("button--secondary");
        }

        if (tabContents[i]) {
          tabContents[i].style.display = "none";
        }
      });

      tab.classList.add("active");
      link.classList.remove("button--secondary");
      link.classList.add("button--primary");

      if (tabContents[index]) {
        tabContents[index].style.display = "block";
      }

      setTimeout(() => {
        if (window.jdgm && typeof window.jdgm.refreshWidgets === "function") {
          window.jdgm.refreshWidgets();
        } else if (window.jdgmShopify && typeof window.jdgmShopify.loadWidgets === "function") {
          window.jdgmShopify.loadWidgets();
        }
      }, 150);
    });
  });
});

// const visibleParagraphs = 1;

// document.querySelectorAll(".tabs-content-wrapper").forEach(function(tabWrapper) {
//   const textContainer = tabWrapper.querySelector(".tabs-content-text");
//   const paragraphs = textContainer ? textContainer.querySelectorAll("p") : [];

//   if (paragraphs.length > visibleParagraphs) {
//     paragraphs.forEach((p, i) => {
//       if (i >= visibleParagraphs) {
//         p.style.display = "none";
//         p.classList.add("extra-paragraph");
//       }
//     });

//     const btn = document.createElement("button");
//     btn.className = "see-more-btn";
//     btn.textContent = "Weiterlesen";
//     textContainer.parentNode.appendChild(btn);

//     btn.addEventListener("click", function () {
//       const hiddenParas = tabWrapper.querySelectorAll(".extra-paragraph");
//       const isHidden = hiddenParas[0].style.display === "none";

//       hiddenParas.forEach(p => {
//         p.style.display = isHidden ? "block" : "none";
//       });

//       btn.textContent = isHidden ? "Weniger anzeigen" : "Weiterlesen";
//     });
//   }
// });




document.querySelectorAll("[review_click]").forEach(function (link) {

    link.addEventListener("click", function (e) {
      const target = document.querySelector("#review_data a");
      if (target) {
        // The star rating above the buy box links to the reviews tab further down
        // (sections/tabs.liquid, #review_data). Clicking the tab link opens it,
        // then we scroll there.
        target.click();

        target.scrollIntoView({
          behavior: "smooth", // smooth scrolling
          block: "start"
        });
      }
    });
  });


  // accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };

  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {

            if (!accordion.closest('.mobile-facets-blog-inner')) {
              accordions.forEach((accordion) => closeAccordion(accordion));
            }

            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });
}
// accordions js end
(function() {
  faq_taggol();
})();

class BlogDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.main-blog-section');

    this.borderOffset =
      this.borderOffset ||
      (this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0);

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    this.header.classList.add('blog-drawer-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('blog-drawer-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('blog-drawer-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    if (this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    }
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

// scroll and load more btn trigger click on collection page

// document.addEventListener("DOMContentLoaded", function () {
//   const container = document.querySelector('[data-pagination-link]');

//   if (!container) return;

//   function checkAndClickButton() {
//     const loadMoreBtn = container.querySelector('[data-pagination-btn]');
//     if (!loadMoreBtn) return;

//     const observer = new IntersectionObserver(
//       (entries, obs) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             // Click the button
//             loadMoreBtn.click();
//             // Stop observing this button instance
//             obs.unobserve(loadMoreBtn);
//             // Check again after a short delay to handle the next button
//             setTimeout(checkAndClickButton, 500);
//           }
//         });
//       },
//       {
//         root: null,
//         rootMargin: "0px",
//         threshold: 0.1,
//       }
//     );

//     observer.observe(loadMoreBtn);
//   }

//   // Initial call
//   checkAndClickButton();
// });
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('[data-pagination-link]');
  if (!container) return;

  let isLoading = false;

  function observeButton() {
    const loadMoreBtn = container.querySelector('[data-pagination-btn]');
    if (!loadMoreBtn || isLoading) return;

    // Button visible na hoy to pan observer work kare
    loadMoreBtn.style.display = 'block';
    loadMoreBtn.style.visibility = 'hidden';

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLoading) {
            isLoading = true;

            // Trigger pagination
            loadMoreBtn.click();

            // Stop observing current button
            obs.unobserve(loadMoreBtn);

            // Wait for new products & next button
            setTimeout(() => {
              isLoading = false;
              observeButton();
            }, 500);
          }
        });
      },
      {
        root: null,
        rootMargin: "200px",
        threshold: 0,
      }
    );

    observer.observe(loadMoreBtn);
  }

  // Start infinite scroll
  observeButton();
});



// blog page filter logic

document.addEventListener("DOMContentLoaded", function () {

  const checkboxes = document.querySelectorAll(".blog-filter-checkbox");
  const resetBtn = document.querySelector(".reset-blog");
  const showBlogResult = document.querySelector(".show-blog-result");
  const allResultContainer = document.querySelector(".all-result");
  const blankEl = document.querySelector(".blank-filter-text");
  const articleCountEl = document.querySelector("[data-article-count]");
  const wrapper = document.querySelector("[data-product-main-wrapper]");
  const paginationWrapper = document.querySelector("[data-pagination-link]");

  if (!wrapper || !articleCountEl) return;

  let currentPage = 1;
  let isLoading = false;

  const countSuffix = articleCountEl.textContent.replace(/\d+/g, "").trim();

  /* ---------------------------------------------------
     MULTI SELECTION PER GROUP
  --------------------------------------------------- */
  document.querySelectorAll("[js-acc-item]").forEach(group => {
    const groupCheckboxes = group.querySelectorAll(".blog-filter-checkbox");

    groupCheckboxes.forEach(cb => {
      cb.addEventListener("change", () => {
        showSelectedFilters();
        applyFilters();
      });
    });
  });

  /* ---------------------------------------------------
     SHOW SELECTED TAGS
  --------------------------------------------------- */
  function showSelectedFilters() {
    allResultContainer.innerHTML = "";
    const selected = [...checkboxes].filter(cb => cb.checked);

    if (!selected.length) {
      showBlogResult.classList.add("hidden");
      return;
    }

    showBlogResult.classList.remove("hidden");

    selected.forEach(cb => {
      const tag = document.createElement("span");
      tag.className = "selected-tag";
      tag.innerHTML = `${cb.dataset.title}
        <span class="remove-tag" data-tag="${cb.value}">✕</span>`;
      allResultContainer.appendChild(tag);
    });
  }

  /* ---------------------------------------------------
     REMOVE TAG
  --------------------------------------------------- */
  allResultContainer.addEventListener("click", e => {
    if (!e.target.classList.contains("remove-tag")) return;

    const val = e.target.dataset.tag;
    const cb = [...checkboxes].find(c => c.value === val);

    if (cb) {
      cb.checked = false;
    }

    showSelectedFilters();
    applyFilters();
  });

  /* ---------------------------------------------------
     RESET ALL FILTERS
  --------------------------------------------------- */
  resetBtn?.addEventListener("click", () => {
    checkboxes.forEach(cb => {
      cb.checked = false;
    });
    showSelectedFilters();
    applyFilters();
  });

  /* ---------------------------------------------------
     APPLY FILTER (AJAX)
  --------------------------------------------------- */
  function applyFilters() {
    currentPage = 1;

    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const base = location.pathname.split("/tagged/")[0];
    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}`
      : base;

    history.pushState(null, "", url);
    fetchPage(url, false, tags); // pass tags to update count
  }

  /* ---------------------------------------------------
     FETCH PAGE
  --------------------------------------------------- */
  function fetchPage(url, append = false, tags = []) {
    if (isLoading) return;
    isLoading = true;
    wrapper.classList.add("is-loading");

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newWrapper = doc.querySelector("[data-product-main-wrapper]");
        const bredcums = doc.querySelector("#bredcurum_main");
        if (!newWrapper) return;

        const newArticles = newWrapper.querySelector(".blog-articles");
        const currentArticles = wrapper.querySelector(".blog-articles");
        const exit_bredcurm = document.querySelector("#bredcurum_main");

        if (!append) {
          wrapper.innerHTML = newWrapper.innerHTML;
        } else if (newArticles && currentArticles) {
          currentArticles.insertAdjacentHTML("beforeend", newArticles.innerHTML);
        }

        if(bredcums) exit_bredcurm.innerHTML = bredcums.innerHTML;

        // 🔹 RESET ALL ACCORDIONS
        document.querySelectorAll("[js-acc-item]").forEach(item => {
          item.classList.remove("active");
          const content = item.querySelector("[js-acc-single-content]");
          if (content) content.style.maxHeight = "";
        });

        // 🔹 UPDATE TOTAL COUNT FROM SERVER
        updateCount(tags, doc);

        updatePagination(doc);

        wrapper.classList.remove("is-loading");
        isLoading = false;
      })
      .catch(() => {
        wrapper.classList.remove("is-loading");
        isLoading = false;
      });
  }

  /* ---------------------------------------------------
     COUNT UPDATE
     🔹 Always fetch total count from server
  --------------------------------------------------- */
function updateCount(selectedTags = [], doc = null) {

  function applyCount(totalCount) {
    const count = isNaN(totalCount) ? 0 : totalCount;

    articleCountEl.textContent = `${count} ${countSuffix}`;

    if (count > 0) {
      blankEl.style.display = "none";
      articleCountEl.style.display = "block";
    } else {
      blankEl.style.display = "block";
      articleCountEl.style.display = "none";
    }
  }

  /* -------------------------------
     IF DOC NOT PASSED → FETCH PAGE
  --------------------------------*/
  if (!doc) {

    const base = location.pathname.split("/tagged/")[0];
    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}`
      : base;

    fetch(url)
      .then(res => res.text())
      .then(html => {

        const parsed = new DOMParser().parseFromString(html, "text/html");

        const totalCountEl = parsed.querySelector("[data-article-count]");

        let totalCount = 0;

        if (totalCountEl) {
          const text = totalCountEl.textContent.trim();
          const match = text.match(/\d+/);
          totalCount = match ? parseInt(match[0], 10) : 0;
        }

        applyCount(totalCount);

      })
      .catch(() => applyCount(0));

    return;
  }

  /* -------------------------------
     DOC PASSED → USE DIRECT COUNT
  --------------------------------*/
  const totalCountEl = doc.querySelector("[data-article-count]");

  let totalCount = 0;

  if (totalCountEl) {
    const text = totalCountEl.textContent.trim();
    const match = text.match(/\d+/);
    totalCount = match ? parseInt(match[0], 10) : 0;
  }

  applyCount(totalCount);
}
  /* ---------------------------------------------------
     PAGINATION UPDATE
  --------------------------------------------------- */
  function updatePagination(doc) {
    if (!paginationWrapper) return;

    const newPagination = doc.querySelector("[data-pagination-link]");
    if (!newPagination || !newPagination.innerHTML.trim()) {
      paginationWrapper.style.display = "none";
      return;
    }

    paginationWrapper.innerHTML = newPagination.innerHTML;
    paginationWrapper.style.display = "block";
  }

  /* ---------------------------------------------------
     PAGINATION CLICK (AJAX)
  --------------------------------------------------- */
  document.addEventListener("click", e => {
    const btn = e.target.closest("[data-pagination-btn]");
    if (!btn) return;

    e.preventDefault();
    if (isLoading) return;

    currentPage++;

    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const base = location.pathname.split("/tagged/")[0];
    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}?page=${currentPage}`
      : `${base}?page=${currentPage}`;

    fetchPage(url, true, tags);
  });

  /* ---------------------------------------------------
  //    INITIAL
  // --------------------------------------------------- */
   showSelectedFilters();
   updateCount(); // fetch total count initially
});

// blog page filter logic for the mobile

document.addEventListener("DOMContentLoaded", function () {

  const checkboxes = document.querySelectorAll(".mobile-filter-checkbox");
  const resetBtn = document.querySelector(".reset-blog");
  const showBlogResult = document.querySelector(".show-blog-result");
  const allResultContainer = document.querySelector(".all-result");
  const blankEl = document.querySelector(".blank-filter-text");
  const articleCountEl = document.querySelector("[data-mobile-count]");
  const wrapper = document.querySelector("[data-product-main-wrapper]");
  const paginationWrapper = document.querySelector("[data-pagination-link]");

  if (!wrapper || !articleCountEl) return;

  let currentPage = 1;
  let isLoading = false;

  const countSuffix = articleCountEl.textContent.replace(/\d+/g, "").trim();

  /* ---------------------------------------------------
     MULTI SELECTION PER GROUP
  --------------------------------------------------- */
  document.querySelectorAll("[js-acc-item]").forEach(group => {
    const groupCheckboxes = group.querySelectorAll(".mobile-filter-checkbox");

    groupCheckboxes.forEach(cb => {
      cb.addEventListener("change", () => {
        showSelectedFilters();
      });
    });
  });

  // Apply filter btn for the mobile
    const applyBtn = document.querySelector(".filter-apply");
    applyBtn?.addEventListener("click", function () {

      const tags = [...checkboxes]
        .filter(cb => cb.checked)
        .map(cb => cb.value);

      const base = location.pathname.split("/tagged/")[0];

      const url = tags.length
        ? `${base}/tagged/${tags.join(",")}`
        : base;

      // 🔹 URL redirect + page reload
      window.location.href = url;

    });

    function showSelectedFilters (){

        const drawerSelected = document
            .querySelector(`.Mobile-Drawer-Selected-Filters`)

        if( drawerSelected )
            drawerSelected.innerHTML = ''

        const selected = [ ... checkboxes ]
            .filter(( checkbox ) => checkbox.checked )

        document
        .querySelectorAll(`.Group-Reset-Button`)
        .forEach(( button ) => {

            const hasChecked = [ ... checkboxes ]
                .some(( checkbox ) => checkbox.checked &&
                    checkbox.dataset.group === button.dataset.group)

            button.style.display = hasChecked
                ? 'inline-block' : 'none'
        })

        if( ! drawerSelected )
            return

        drawerSelected.style.display =
            ( selected.length ) ? 'block' : 'none'

        if( ! selected.length )
            return

        selected.forEach(( checkbox ) => {

            const tag = document.createElement('span')
            tag.className = 'Mobile-Selected-Tag'
            tag.innerHTML = `
                ${ checkbox.dataset.group }: ${ checkbox.dataset.title }
                <span
                    data-tag = '${ checkbox.value }'
                    class = 'remove-tag'
                >x</span>
            `

            drawerSelected.appendChild(tag)
        })
    }


    [
        document.querySelector(`.mobile-facets-blog-inner`) ,
        allResultContainer
    ].forEach(( element ) => {
        element?.addEventListener('click',( event ) => {

            const { target } = event

            if( ! target.classList.contains('remove-tag') )
                return

            const tag = target.dataset.tag

            const checkbox = [ ... checkboxes ]
                .find(( checkbox ) => checkbox.value === tag )

            if( checkbox )
                checkbox.checked = false

            showSelectedFilters()
        })
    })


    document
    .querySelectorAll(`.Group-Reset-Button`)
    .forEach(( button ) => {

        button.addEventListener('click',( event ) => {

            event.stopPropagation()

            const group = button.dataset.group

            checkboxes
            .filter(( checkbox ) => checkbox.dataset.group === group )
            .forEach(( checkbox ) => checkbox.checked = false )

            showSelectedFilters()
        })
    })

  /* ---------------------------------------------------
     RESET ALL FILTERS
  --------------------------------------------------- */
  resetBtn?.addEventListener("click", () => {
    checkboxes.forEach(cb => {
      cb.checked = false;
    });
    showSelectedFilters();
    applyFilters();
  });

  /* ---------------------------------------------------
     APPLY FILTER (AJAX)
  --------------------------------------------------- */
  function applyFilters() {
    currentPage = 1;

    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const base = location.pathname.split("/tagged/")[0];
    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}`
      : base;

    history.pushState(null, "", url);
    fetchPage(url, false, tags); // pass tags to update count
  }

  /* ---------------------------------------------------
     FETCH PAGE
  --------------------------------------------------- */
  function fetchPage(url, append = false, tags = []) {
    if (isLoading) return;
    isLoading = true;
    wrapper.classList.add("is-loading");

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newWrapper = doc.querySelector("[data-product-main-wrapper]");
        const bredcums = doc.querySelector("#bredcurum_main");
        if (!newWrapper) return;

        const newArticles = newWrapper.querySelector(".blog-articles");
        const currentArticles = wrapper.querySelector(".blog-articles");
        const exit_bredcurm = document.querySelector("#bredcurum_main");

        if (!append) {
          wrapper.innerHTML = newWrapper.innerHTML;
        } else if (newArticles && currentArticles) {
          currentArticles.insertAdjacentHTML("beforeend", newArticles.innerHTML);
        }

        if(bredcums) exit_bredcurm.innerHTML = bredcums.innerHTML;

        // 🔹 RESET ALL ACCORDIONS
        document.querySelectorAll("[js-acc-item]").forEach(item => {
          item.classList.remove("active");
          const content = item.querySelector("[js-acc-single-content]");
          if (content) content.style.maxHeight = "";
        });

        // 🔹 UPDATE TOTAL COUNT FROM SERVER
        updateCount(tags, doc);

        updatePagination(doc);

        wrapper.classList.remove("is-loading");
        isLoading = false;
      })
      .catch(() => {
        wrapper.classList.remove("is-loading");
        isLoading = false;
      });
  }

  /* ---------------------------------------------------
     COUNT UPDATE
     🔹 Always fetch total count from server
  --------------------------------------------------- */
function updateCount(selectedTags = [], doc = null) {

  function applyCount(totalCount) {
    const count = isNaN(totalCount) ? 0 : totalCount;

    articleCountEl.textContent = `${count} ${countSuffix}`;

    if (count > 0) {
      blankEl.style.display = "none";
      articleCountEl.style.display = "block";
    } else {
      blankEl.style.display = "block";
      articleCountEl.style.display = "none";
    }
  }

  /* -------------------------------
     IF DOC NOT PASSED → FETCH PAGE
  --------------------------------*/
  if (!doc) {

    const base = location.pathname.split("/tagged/")[0];
    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}`
      : base;

    fetch(url)
      .then(res => res.text())
      .then(html => {

        const parsed = new DOMParser().parseFromString(html, "text/html");

        const totalCountEl = parsed.querySelector("[data-mobile-count]");

        let totalCount = 0;

        if (totalCountEl) {
          const text = totalCountEl.textContent.trim();
          const match = text.match(/\d+/);
          totalCount = match ? parseInt(match[0], 10) : 0;
        }

        applyCount(totalCount);

      })
      .catch(() => applyCount(0));

    return;
  }

  /* -------------------------------
     DOC PASSED → USE DIRECT COUNT
  --------------------------------*/
  const totalCountEl = doc.querySelector("[data-mobile-count]");

  let totalCount = 0;

  if (totalCountEl) {
    const text = totalCountEl.textContent.trim();
    const match = text.match(/\d+/);
    totalCount = match ? parseInt(match[0], 10) : 0;
  }

  applyCount(totalCount);
}
  /* ---------------------------------------------------
     PAGINATION UPDATE
  --------------------------------------------------- */
  function updatePagination(doc) {
    if (!paginationWrapper) return;

    const newPagination = doc.querySelector("[data-pagination-link]");
    if (!newPagination || !newPagination.innerHTML.trim()) {
      paginationWrapper.style.display = "none";
      return;
    }

    paginationWrapper.innerHTML = newPagination.innerHTML;
    paginationWrapper.style.display = "block";
  }

  /* ---------------------------------------------------
     PAGINATION CLICK (AJAX)
  --------------------------------------------------- */
  document.addEventListener("click", e => {
    const btn = e.target.closest("[data-pagination-btn]");
    if (!btn) return;

    e.preventDefault();
    if (isLoading) return;

    currentPage++;

    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const base = location.pathname.split("/tagged/")[0];
    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}?page=${currentPage}`
      : `${base}?page=${currentPage}`;

    fetchPage(url, true, tags);
  });

  /* ---------------------------------------------------
  //    INITIAL
  // --------------------------------------------------- */
   showSelectedFilters();
   updateCount(); // fetch total count initially
});// end mobile


// blog rexept page link for the mobile
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".rk_has_link");

  links.forEach(function (element) {
    element.addEventListener("click", function (e) {

      const parentLi = this.closest("li");
      if (!parentLi) return;

      const target = parentLi.querySelector(".rk_print_hide");
      if (!target) return;

      const isAlreadyActive = target.classList.contains("print-btn");

      // Remove class from all first
      document.querySelectorAll(".rk_print_hide").forEach(function (el) {
        el.classList.remove("print-btn");
      });

      if (!isAlreadyActive) {
        // First click → prevent redirect + add class
        e.preventDefault();
        target.classList.add("print-btn");
      }
      // Second click → no preventDefault → redirect will work
    });
  });
});
